import { Autocomplete, Box, Button, Grid, TextField, Typography, useTheme } from "@mui/material";
import { useEffect } from "react";
import { useRrhh } from "../../../../shared/context/rrhhContext";
import { useOt } from "../../../../shared/context/otContext";
import { useUtiles } from "../../../../shared/context/utilesContext";
import Swal from "sweetalert2";
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';

export default function ChangeAsignedOT() {
    const theme = useTheme()
    const { rrhh, loadingGetRrhh, getRrhh, getRrhhByName, loadingGetRrhhByName, rrhhByName } = useRrhh()
    const { otChangeAsignedOt, setOtChangeAsignedOt, otChangeExtraTech, setOtChangeExtraTech, loadingChangeAsignedOt, changeAsignedOtAndExtraTech, ot } = useOt()
    const {getFirstNameAndLastName, resetOpenSilder} = useUtiles()

    //si la ot tiene un responsable, se debe setear en el autocomplete
    useEffect(() => {
        if (ot.assigned_users && ot.assigned_users.length > 0) {
            setOtChangeAsignedOt(ot.assigned_users[0])
        }
    }, [ot])

    //si la ot tiene apoyo técnico extra, se debe setear en el autocomplete
    useEffect(() => {
        if (ot.assigned_extra_users && ot.assigned_extra_users.length > 0) {
            // Ensure we don't have duplicates by using a Set with a custom comparator
            const uniqueUsers = Array.from(new Set(ot.assigned_extra_users.map(user => user.id)))
                .map(id => ot.assigned_extra_users.find(user => user.id === id));
            setOtChangeExtraTech(uniqueUsers)
        }
    }, [ot])

    //Si se cambia el responsable verificar si el nuevo responsable esta como apoyo técnico extra y notificar al usuario que ya no es apoyo técnico extra
    useEffect(() => {
        if (otChangeAsignedOt && otChangeExtraTech.find(user => user.id === otChangeAsignedOt.id)) {
            Swal.fire({
                title: 'El nuevo responsable ya es apoyo técnico extra',
                text: `Primero debes quitar a ${getFirstNameAndLastName(otChangeAsignedOt.fullName)} como apoyo técnico extra`,
                icon: 'error',
                confirmButtonText: 'Aceptar',
                customClass: {
                    container: 'custom-swal2-container',
                    popup: 'custom-swal2-popup',
                    backdrop: 'custom-swal2-backdrop',
                }
            })
            //Si el nuevo responsa ya esta como apoyo técnico extra, se debe volver al anterior
            setOtChangeAsignedOt(ot.assigned_users[0])
        }
    }, [otChangeAsignedOt, otChangeExtraTech])

    // Handle changes to extra tech, preventing duplicates
    const handleExtraTechChange = (e, newValue) => {
        // Remove any duplicates based on id
        const uniqueValues = Array.from(new Set(newValue.map(user => user.id)))
            .map(id => newValue.find(user => user.id === id));
        setOtChangeExtraTech(uniqueValues);
    };


    const handleClose = () => {
        setOtChangeAsignedOt(null)
        setOtChangeExtraTech([])
        resetOpenSilder()
    }

    return (
        <Box sx={{ p: 2 }}>
            <Grid container spacing={2}>
                <Grid item size={{ xs: 12}}>
                    <Typography variant="title" sx={{ fontWeight: 'bold', fontSize: '14px', color: theme.palette.text.primary }}>Responsable de la OT</Typography>
                    <Autocomplete
                        options={rrhhByName}
                        loading={loadingGetRrhhByName}
                        getOptionLabel={(option) => getFirstNameAndLastName(option.fullName)}
                        renderInput={(params) => <TextField {...params}  />}
                        onChange={(e, value) => setOtChangeAsignedOt(value)}
                        value={otChangeAsignedOt}
                        onOpen={() => { getRrhhByName({ user_task_attender: true }) }}
                        onInputChange={(e, value) => {
                            getRrhhByName({ user_task_attender: true, fullName: value })
                        }}
                    />
                </Grid>

                <Grid item size={{ xs: 12 }}>
                    <Typography variant="title" sx={{ fontWeight: 'bold', fontSize: '14px', color: theme.palette.text.primary }}>Apoyo técnico extra:</Typography>
                    <Autocomplete
                        options={rrhh}
                        multiple
                        onChange={handleExtraTechChange}
                        loading={loadingGetRrhh}
                        getOptionLabel={(option) => getFirstNameAndLastName(option.fullName)}
                        renderInput={(params) => <TextField {...params}  />}
                        value={otChangeExtraTech}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        onOpen={() => { getRrhh({ user_task_attender: true, exclude: otChangeAsignedOt?.num_document }) }}
                        onInputChange={(e, value) => {
                            getRrhh({ user_task_attender: true, fullName: value, exclude: otChangeAsignedOt?.num_document })
                        }}
                    />
                </Grid>

                <Grid item size={{ xs: 12 }}>
                    <Button startIcon={<SaveIcon />} variant="contained" color="primary" onClick={() => changeAsignedOtAndExtraTech({ otChangeAsignedOt, otChangeExtraTech })} >Aplicar cambios</Button>
                    <Button startIcon={<CancelIcon />} variant="contained" color="disabled" sx={{ ml: 1 }} onClick={handleClose} >Cancelar</Button>
                </Grid>
            </Grid>
        </Box>
    )
}